module.exports = __webpack_public_path__ + "res/img_button_bg.b70a7d2ecd52564b6222db41dc930c46.png";